import React from 'react';
import { ShieldAlert } from 'lucide-react';
export function VillainSection() {
  return <section className="py-4 md:py-14 px-6 bg-white border-y border-navy/5" data-id="element-370">
      <div className="max-w-3xl mx-auto text-center" data-id="element-371">
        <div className="inline-flex items-center justify-center w-16 h-16 rounded-full bg-red-50 mb-6" data-id="element-372">
          <ShieldAlert className="w-8 h-8 text-red-500" data-id="element-373" />
        </div>
        <h2 className="text-4xl md:text-5xl font-bold text-navy mb-8" data-id="element-374">
          No es tu culpa.
        </h2>

        <div className="text-lg md:text-xl text-navy/80 leading-relaxed space-y-6 text-left bg-background p-8 md:p-10 rounded-2xl shadow-sm" data-id="element-375">
          <p data-id="element-376">
            Has estado siguiendo el{' '}
            <strong className="text-navy" data-id="element-377">"Manual de Supervivencia"</strong> que
            que nos impone la productividad moderna. 
          </p>
          <p data-id="element-378">            
            Ese que dice que si estás cansado necesitás otra taza de café, que la falta de foco se cura con "fuerza de voluntad" y que vivir con niebla mental es el{' '}
            <strong className="text-navy" data-id="element-379">
              precio inevitable de la vida profesional — o simplemente "cosas de la edad".
            </strong>
          </p>
          <p data-id="element-380">
            Esa información está diseñada para que sigas dependiendo de {' '}
            <strong className="text-navy" data-id="element-381">parches temporales</strong> para  {' '}
            <strong className="text-navy" data-id="element-382">"mantener el metabolismo activo".</strong>  
          </p>
          <p className="font-semibold text-navy border-l-4 border-accent pl-4" data-id="element-383">
            Mientras sigas ese manual, tu{' '}
            <span className="text-accent" data-id="element-384">"Motor Celular"</span> seguirá funcionando en modo de ahorro, y tu claridad seguirá siendo el rehén de tu cansancio.
          </p>
        </div>
      </div>
    </section>;
}